var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"auth-wrapper"},[_c('amplify-authenticator',{attrs:{"slot":"sign-in","id":"auth","authConfig":_vm.configurationOptions,"usernameAlias":"email"},slot:"sign-in"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }